import React from 'react';

export function Services() {
  const services = [
    { title: 'For Individuals', points: ['Income', 'Tax planning & preparation', 'Filing status guidance','Multi-State issues','Foreign reporting rules','Gift tax reporting','Trust and estate tax services', 'Personal financial statement preparation'], imagesrc:'/PERSONALTAX.png' },
    { title: 'For Businesses', points: ['Tax Filings' , 'Planning & strategy', 'Financial statement preparation', 'Fractional CFO services'], imagesrc:'/SCORP.png' },
    ,
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
        {services.map((svc) => (
          <div
            key={svc.title}
            className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 flex flex-col justify-between"
          >
            <div>
              <h2 className="text-2xl font-semibold mb-4 text-primary text-center">{svc.title}</h2>
              <ul className={`list-disc list-inside text-gray-700 text-left ${svc.title === 'For Businesses' ? 'space-y-6' : 'space-y-1.5'}`}>
                {svc.points.map((pt) => (
                  <li key={pt}>{pt}</li>
                ))}
              </ul>
            </div>

            {/* Image at the bottom, centered */}
            <div className="mt-6 flex justify-center">
              <img src={svc.imagesrc} alt={svc.title} className="h-22 w-auto" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}